import {z} from 'zod';

export const XentryInformationFormSchema = z
  .object({
    damageCode: z.string().max(9).nullish(),
    isGrounded: z.boolean().nullish(),
    groundingReason: z.string().nullish(),
  })
  .refine(
    (data) =>
      data.isGrounded !== true || (data.groundingReason != null && data.groundingReason !== ''),
    {message: 'Grounding reason is required when vehicle is grounded', path: ['groundingReason']}
  );

export type XentryInformationFormType = z.infer<typeof XentryInformationFormSchema>;
